import{ MySlide } from './my-slide/my-slide';
import{ BrowserPage } from './browser/browser';
/*********
 * 公共组件中心
 *
 * ***********/
export const COMM_INDEX = [
  MySlide,
  BrowserPage,
];



// WEBPACK FOOTER //
// ./src/pages/comm/index.ts